import { Avatar } from 'antd'
import { FC } from 'react'
import { TCallStatus } from '../types'

// Calls that never connected get the crossed-out handset, otherwise the in/out arrow variants
const MISSED_STATUSES: TCallStatus[] = ['no-answer', 'busy', 'failed']

const getStatusColor = (status?: TCallStatus) => {
 switch (status) {
  case 'completed':
  case 'answered':
   return '#28a745'
  case 'failed':
  case 'busy':
  case 'no-answer':
   return '#ED1C24'
  default:
   return undefined
 }
}

const CallDirectionAvatar: FC<{
 direction?: 'inbound' | 'outbound'
 status?: TCallStatus
 size?: number
}> = ({ direction, status, size = 50 }) => {
 const isMissed = !!status && MISSED_STATUSES.includes(status)
 const statusColor = getStatusColor(status)
 const directionClass = direction === 'inbound' ? 'is-inbound' : 'is-outbound'

 return (
  <span className="call-item-avatar-wrap">
   <Avatar
    size={size}
    icon={
     <i
      className={`fas fa-phone-alt call-item-avatar-icon ${directionClass}`}
      style={{ color: statusColor }}
     />
    }
   />
   <i
    className={`fas call-item-direction-badge ${
     isMissed ? 'fa-times is-missed' : `fa-arrow-up ${directionClass}`
    }`}
    style={{ color: isMissed ? undefined : statusColor }}
   />
  </span>
 )
}

export default CallDirectionAvatar
